<template>
  <div class="tg-mobile-not-mask mobile_not_mask" v-show="showMask"></div>
  <div class="mask_btn_wrap" v-show="showMask">
    <a class="mask_btn top_radius" v-text="cellPhone" :href="'tel:' + cellPhone" ref="telPhone"></a>
    <div style="width: 100%;height: 10px;background-color: #e1e1e1;"></div>
    <div class="mask_btn" @click="cancelClick">取消</div>
  </div>
</template>
<script>

import tgSession from "javascript/libs/tg/util/tgSession";

export default {
  props: {
    showMask: {
      type: Boolean
      , default: false
    }
  },
  watch: {
    showMask(newVal, oldVal) {
      this.showMask = newVal;
    }
  }
  , data: function () {
    return {
      // cellPhone: "041139872520",
      cellPhone: null,
    };
  },
    created() {
      this.cellPhone = tgSession.getItem('kefuTel') || '041139872520';
    },
    methods: {
    cancelClick: function () {
      this.$emit("cancelcallback", false);
    },
  }
};
</script>
<style lang="scss">
.mobile_not_mask {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: #000;
  opacity: .5;
  z-index: 999;
}

.mask_btn_wrap {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  opacity: 1;
}

.mask_btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 50px;
  color: #000000 !important;
  background-color: #ffffff;
  font-size: 16px;
}

.mask_btn.top_radius {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
</style>